<template>
  <div class="flex flex-row justify-start">
    <instant-image v-for='image in imagesWithUrl'
                   :image='image' 
                   :is-selected='image.id === selectedImage.id'
                   @select='onSelectImage'
                   :key='image.id' />
  </div>
</template>
<script>
import InstantImage from '@ui/atoms/InstantImage.vue';
export default {
  inject: ['api'],
  props: {
    images: {
      type: Array,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedImage: {}
    }
  },
  methods: {
    onSelectImage(image) {
      this.selectedImage = image;
      this.$emit('select', {
        image,
      })
    },
    deselect() {
      this.selectedImage = {};
    }

  },
  components: {
    InstantImage
  },
  computed: {
    imagesWithUrl() {
      return this.images.map( ({image}) => {
        console.log('image', image);
        return Object.assign(
          {},
          image,
          {url:this.api.makeImageUrlEditor(image.id)}
        )
      });
    }
  }
}
</script>
